/**
 * Category rail behaviour — two jobs, both progressive enhancement over working links:
 *
 * 1. The mobile <select> navigates on change. The rail's links do the same job above
 *    1024px with no JavaScript at all.
 * 2. On hover-capable devices, the floating category photograph follows the pointer a
 *    few pixels around each entry's centre — the reference's magnet effect. The image
 *    URL rides on `data-thumb` and is only promoted to a background image on first
 *    pointerenter, so touch devices and visitors who never hover download nothing.
 *
 * A custom element because `component-facets.js` replaces the whole section's markup on
 * every filter apply: the freshly parsed <sub-collections> upgrades and rebinds itself,
 * where an init-on-load script would leave the swapped-in copy inert.
 */
(function () {
  'use strict';

  if (customElements.get('sub-collections')) return;

  class SubCollections extends HTMLElement {
    connectedCallback() {
      const select = this.querySelector('[data-subcollections-select]');
      if (select) {
        select.addEventListener('change', () => {
          if (select.value) window.location.href = select.value;
        });
      }

      // No pointer worth following, or a visitor who asked for stillness — the CSS
      // hides the thumb under the same conditions, so binding these would only track
      // a pointer for an element that never shows.
      const hover = window.matchMedia('(any-hover: hover)');
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (!hover.matches || reduce.matches) return;

      const magnet = Number(this.dataset.magnet) || 80;

      this.querySelectorAll('.subcollections__link[data-thumb]').forEach((link) => {
        const item = link.closest('.subcollections__item');
        const thumb = item && item.querySelector('.subcollections__thumb');
        if (!thumb) return;

        link.addEventListener('pointerenter', () => {
          if (!thumb.style.backgroundImage) {
            thumb.style.backgroundImage = 'url("' + link.dataset.thumb + '")';
          }
          item.classList.add('is-peeking');
          item.classList.remove('is-leaving');
        });

        link.addEventListener('pointermove', (event) => {
          const rect = item.getBoundingClientRect();
          const x = ((event.clientX - rect.left) / rect.width - 0.5) * magnet;
          const y = ((event.clientY - rect.top) / rect.height - 0.5) * magnet;
          thumb.style.transform = 'translate(-50%, -50%) translate(' + x + 'px, ' + y + 'px)';
        });

        link.addEventListener('pointerleave', () => {
          item.classList.add('is-leaving');
          item.classList.remove('is-peeking');
          thumb.style.transform = 'translate(-50%, -50%)';
        });
      });
    }
  }

  customElements.define('sub-collections', SubCollections);
})();
